<!-- スキルアップ登録 -->
<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section v-if="isDataFetched" class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">
          <template v-if="isEditModeUpdate">
            {{ contentsCaategoryName }}更新
          </template>
          <template v-else>{{ contentsCaategoryName }}登録</template>
        </h2>
        <div
          v-if="errorMessage"
          class="error-message"
          style="white-space: pre-wrap"
        >
          {{ errorMessage }}
        </div>

        <table>
          <thead>
            <tr>
              <th style="width: 4%"></th>
              <th style="width: 7%"></th>
              <th style="width: 11%"></th>
              <th style="width: 17%"></th>
              <th style="width: 9%"></th>
              <th style="width: 28%"></th>
              <th style="width: 11%"></th>
              <th style="width: 13%"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="form-control-title">ID</td>
              <td>{{ contentsData.contentsId }}</td>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                サブカテゴリ
              </td>
              <td>
                <select
                  id="cmbSubCategory"
                  class="form-control"
                  v-model="contentsData.subCategoryId"
                  ref="cmbSubCategory"
                >
                  <option></option>
                  <option
                    v-for="item in subCategoryList"
                    :key="item.subCategoryId"
                    :value="item.subCategoryId"
                  >
                    {{ item.subCategoryName }}
                  </option>
                </select>
              </td>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                掲載期間
              </td>
              <td>
                <input
                  type="date"
                  id="txtDispDtFrom"
                  class="form-control"
                  v-model="contentsData.keisaiKikanStart"
                  :max="AppConstants.MAX_DATE_VALUE"
                />
                <label style="margin: 0rem 0.2rem">～</label>
                <input
                  type="date"
                  id="txtDispDtTo"
                  class="form-control"
                  v-model="contentsData.keisaiKikanEnd"
                  :max="AppConstants.MAX_DATE_VALUE"
                />
              </td>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                最終更新日付
              </td>
              <td>
                <input
                  type="date"
                  id="txtLastUpdDt"
                  class="form-control"
                  v-model="contentsData.lastUpdate"
                  :max="AppConstants.MAX_DATE_VALUE"
                />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="form-control-title">
                <label class="required-mark">※</label>
                タイトル
              </td>
              <td colspan="2">
                <input
                  type="text"
                  id="txtTitle"
                  maxlength="255"
                  class="form-control"
                  v-model="contentsData.title"
                />
              </td>
              <td colspan="4"></td>
            </tr>
          </tbody>
        </table>

        <div class="form-inline flex-container">
          <div class="form-group" style="width: 35%; margin-right: 1rem">
            <fieldset>
              <legend>表示対象</legend>
              <div class="form-group">
                <input
                  type="radio"
                  id="rdoAll"
                  name="hyojiTaisho"
                  :value="ContentRegConstants.HYOJI_TAISHO_ALL"
                  class="form-check-input"
                  v-model="contentsData.hyojiTaisho"
                  v-on:change="onChangeHyojiTaisho"
                />
                <label for="rdoAll" class="form-check-label">全員</label>
              </div>
              <div class="form-group">
                <input
                  type="radio"
                  id="rdoAgSegment"
                  name="hyojiTaisho"
                  :value="ContentRegConstants.HYOJI_TAISHO_AG_SEGMENT"
                  class="form-check-input"
                  v-model="contentsData.hyojiTaisho"
                  v-on:change="onChangeHyojiTaisho"
                />
                <label for="rdoAgSegment" class="form-check-label">
                  エージェントセグメント
                </label>
              </div>
              <div class="form-group">
                <select
                  id="cmbAgSegment"
                  class="form-control"
                  v-model="contentsData.agSegmentId"
                  v-bind:disabled="!isHyojiTaishoAgSegment"
                >
                  <option></option>
                  <option
                    v-for="item in agSegmentList"
                    :key="item.agSegmentCode"
                    :value="item.agSegmentCode"
                  >
                    {{ item.agSegmentCode }}：{{ item.agSegmentName }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <input
                  type="radio"
                  id="rdoAg"
                  name="hyojiTaisho"
                  :value="ContentRegConstants.HYOJI_TAISHO_AG_CODE"
                  class="form-check-input"
                  v-model="contentsData.hyojiTaisho"
                  v-on:change="onChangeHyojiTaisho"
                />
                <label for="rdoAg" class="form-check-label">
                  個別エージェント
                </label>
              </div>
              <div class="form-group">
                <label>AGコード</label>
                <input
                  type="text"
                  id="txtAgCode"
                  maxlength="8"
                  class="form-control"
                  v-model="contentsData.agCode"
                  v-bind:disabled="
                    !isHyojiTaishoAgCode || contentsData.agCodeList.length > 0
                  "
                />
              </div>
              <div class="form-group">
                <div class="file-upload">
                  <button
                    :class="[
                      'btn',
                      'btn-sm',
                      isHyojiTaishoAgCode ? 'btn-primary' : 'btn-secondary',
                    ]"
                    @click="onAgCodeFileUpload"
                    v-bind:disabled="!isHyojiTaishoAgCode"
                  >
                    アップロード
                  </button>
                  <input
                    type="file"
                    :accept="hyojiTaishoExtensions.join(',')"
                    @change="handleAgCodeFileUpload"
                    v-bind:disabled="!isHyojiTaishoAgCode"
                    ref="agCodeFileInput"
                    style="display: none"
                  />
                </div>
                <label
                  style="margin-left: 1rem"
                  v-show="contentsData.agCodeList.length > 0"
                >
                  {{ getValueAgCodeUploadCnt }}
                </label>
              </div>
            </fieldset>
          </div>
          <div class="form-group" style="width: 65%; min-height: 210px">
            <label class="required-mark">※</label>
            <label>本文</label>
            <QuillEditor
              id="rtxtHonbun"
              @update:content="handleContentUpdate"
              v-model="contentsData.body"
              style="height: 210px"
            />
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th style="width: 20%"></th>
              <th style="width: 3%"></th>
              <th style="width: 22%"></th>
              <th style="width: 10%"></th>
              <th style="width: 3%"></th>
              <th style="width: 42%"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in contentsData.contentsLinkList"
              :key="item.rowNo"
            >
              <td v-if="index == 0" class="form-control-title">
                リンクキャプション
              </td>
              <td v-else></td>
              <td>{{ index + 1 }}</td>
              <td>
                <input
                  type="text"
                  maxlength="255"
                  class="form-control"
                  v-model="item.caption"
                />
              </td>
              <td v-if="index == 0" class="form-control-title">リンクURL</td>
              <td v-else></td>
              <td>{{ index + 1 }}</td>
              <td>
                <input
                  type="text"
                  maxlength="255"
                  class="form-control"
                  v-model="item.url"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <table>
          <thead>
            <tr>
              <th style="width: 20%"></th>
              <th style="width: 3%"></th>
              <th style="width: 27%"></th>
              <th style="width: 10%"></th>
              <th style="width: 40%"></th>
            </tr>
          </thead>
          <tbody>
            <!-- 添付ファイル -->
            <tr>
              <td
                :class="[
                  'form-control-title',
                  { 'vertical-align-top': hasContentsTempFile },
                ]"
              >
                添付ファイル
              </td>
              <td colspan="4">
                <div class="file-upload">
                  <button
                    class="btn btn-primary btn-sm"
                    @click="
                      onContentsFileUpload(
                        ContentRegConstants.TRIGGER_TEMP_FILE
                      )
                    "
                  >
                    +
                  </button>
                  <input
                    type="file"
                    :accept="tempFileExtensions.join(',')"
                    @change="handleContentsFileSelected"
                    ref="tempFileInput"
                    style="display: none"
                  />
                </div>
                <div
                  v-for="item in contentsData.contentsTempFileList"
                  :key="item.rowNo"
                >
                  <button
                    class="btn btn-danger btn-sm"
                    @click="
                      onRemoveContentsFile(
                        item.rowNo,
                        ContentRegConstants.TRIGGER_TEMP_FILE
                      )
                    "
                  >
                    -
                  </button>
                  {{ item.fileName }}
                </div>
              </td>
            </tr>
            <tr>
              <td class="form-control-title">添付ファイル説明</td>
              <td colspan="4">
                <input
                  type="text"
                  maxlength="255"
                  class="form-control"
                  v-model="contentsData.contentsTempFileExp"
                  v-bind:disabled="!hasContentsTempFile"
                />
              </td>
            </tr>
            <!-- 画像ファイル -->
            <tr>
              <td
                :class="[
                  'form-control-title',
                  { 'vertical-align-top': hasContentsImgFile },
                ]"
              >
                画像ファイル
              </td>
              <td colspan="4">
                <div class="file-upload">
                  <button
                    class="btn btn-primary btn-sm"
                    @click="
                      onContentsFileUpload(ContentRegConstants.TRIGGER_IMG_FILE)
                    "
                  >
                    +
                  </button>
                  <input
                    type="file"
                    :accept="imgFileExtensions.join(',')"
                    @change="handleContentsFileSelected"
                    ref="imgFileInput"
                    style="display: none"
                  />
                </div>
                <div
                  v-for="item in contentsData.contentsImgList"
                  :key="item.rowNo"
                >
                  <button
                    class="btn btn-danger btn-sm"
                    @click="
                      onRemoveContentsFile(
                        item.rowNo,
                        ContentRegConstants.TRIGGER_IMG_FILE
                      )
                    "
                  >
                    -
                  </button>
                  {{ item.fileName }}
                </div>
              </td>
            </tr>
            <tr>
              <td class="form-control-title">画像ファイル説明</td>
              <td colspan="4">
                <input
                  type="text"
                  maxlength="255"
                  class="form-control"
                  v-model="contentsData.contentsImgFileExp"
                  v-bind:disabled="!hasContentsImgFile"
                />
              </td>
            </tr>
            <!-- 動画ファイル -->
            <tr>
              <td
                :class="[
                  'form-control-title',
                  { 'vertical-align-top': hasContentsVideoFile },
                ]"
              >
                動画ファイル
              </td>
              <td colspan="4">
                <div class="file-upload">
                  <button
                    class="btn btn-primary btn-sm"
                    @click="
                      onContentsFileUpload(
                        ContentRegConstants.TRIGGER_VIDEO_FILE
                      )
                    "
                  >
                    +
                  </button>
                  <input
                    type="file"
                    :accept="videoFileExtensions.join(',')"
                    @change="handleContentsFileSelected"
                    ref="videoFileInput"
                    style="display: none"
                  />
                </div>
                <div
                  v-for="item in contentsData.contentsVideoList"
                  :key="item.rowNo"
                >
                  <button
                    class="btn btn-danger btn-sm"
                    @click="
                      onRemoveContentsFile(
                        item.rowNo,
                        ContentRegConstants.TRIGGER_VIDEO_FILE
                      )
                    "
                  >
                    -
                  </button>
                  {{ item.fileName }}
                </div>
              </td>
            </tr>
            <tr>
              <td class="form-control-title">動画ファイル説明</td>
              <td colspan="4">
                <input
                  type="text"
                  maxlength="255"
                  class="form-control"
                  v-model="contentsData.contentsVideoFileExp"
                  v-bind:disabled="!hasContentsVideoFile"
                />
              </td>
            </tr>
            <!-- タグ -->
            <tr>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                検索用タグ
              </td>
              <td>
                <button
                  class="btn btn-primary btn-sm"
                  @click="openKensakuTagModal"
                >
                  +
                </button>
                <Modal
                  :isOpen="isOpenKensakuTagModal"
                  :tags="kensakuTagModalodalTags"
                  @close="closeKensakuTagModal"
                  @updateTags="updateKensakuTags"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  readonly="true"
                  :value="getValueKensakuTag"
                />
              </td>
              <td class="form-control-title">管理用タグ</td>
              <td>
                <input
                  type="text"
                  maxlength="500"
                  class="form-control"
                  v-model="contentsData.kanriTag"
                />
              </td>
            </tr>
            <tr>
              <td colspan="4"></td>
              <td>※タグはカンマ区切りで入力してください</td>
            </tr>
          </tbody>
        </table>
        <br />
        <table>
          <thead>
            <tr>
              <th style="width: 20%"></th>
              <th style="width: 7%"></th>
              <th style="width: 18%"></th>
              <th style="width: 20%"></th>
              <th style="width: 25%"></th>
              <th style="width: 10%"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                スキルアップ名
              </td>
              <td colspan="2">
                <select
                  id="cmbSkilup"
                  class="form-control"
                  v-model="contentsData.skilupId"
                  ref="cmbSkilup"
                  v-on:change="onChangeSkilupList('')"
                >
                  <option></option>
                  <option
                    v-for="item in skilupList"
                    :key="item.skilupId"
                    :value="item.skilupId"
                  >
                    {{ item.skilupName }}
                  </option>
                </select>
              </td>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                フェーズ
              </td>
              <td>
                <select
                  id="cmbPhase"
                  class="form-control"
                  v-model="contentsData.phaseId"
                  ref="cmbPhase"
                  v-bind:disabled="isSNonelectedSkilup"
                >
                  <option></option>
                  <option
                    v-for="item in selectedSkilupPhaseList"
                    :key="item.phaseId"
                    :value="item.phaseId"
                  >
                    {{ item.phaseName }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="form-control-title">サムネイル画像</td>
              <td>
                <div class="file-upload">
                  <button
                    v-if="contentsData.thumbnailFileList.length > 0"
                    class="btn btn-danger"
                    @click="onThumbnailClear()"
                  >
                    クリア
                  </button>
                  <button
                    v-else
                    class="btn btn-primary"
                    @click="
                      onContentsFileUpload(
                        ContentRegConstants.TRIGGER_THUMBNAIL_FILE
                      )
                    "
                  >
                    参照
                  </button>
                  <input
                    type="file"
                    :accept="thumbnailFileExtensions.join(',')"
                    @change="handleContentsFileSelected"
                    ref="thumbnailFileInput"
                    style="display: none"
                  />
                </div>
              </td>
              <td v-if="contentsData.thumbnailFileList.length > 0" colspan="3">
                {{ contentsData.thumbnailFileList[0].fileName }}
              </td>
              <td v-else colspan="2">
                <select
                  id="cmbTunbnail"
                  class="form-control"
                  v-model="contentsData.thumbnailFile"
                  ref="cmbTunbnail"
                >
                  <option></option>
                  <option
                    v-for="item in thumbNailList"
                    :key="item.thumbnailId"
                    :value="item.thumbnailFileName"
                  >
                    {{ item.thumbnailName }}
                  </option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <th style="width: 30%"></th>
            <th style="width: 40%"></th>
            <th style="width: 30%"></th>
          </thead>
          <tbody>
            <td style="text-align: left">
              <button
                type="button"
                name="btnDelete"
                class="btn btn-footer btn-primary"
                @click="onDelete"
                v-show="isEditModeUpdate"
              >
                削除
              </button>
            </td>
            <td style="text-align: center">
              <button
                type="button"
                name="btnPreview"
                class="btn btn-footer btn-primary"
                @click="onPreview"
                v-show="isEditModeUpdate"
              >
                プレビュー
              </button>
            </td>
            <td style="text-align: right">
              <button
                type="button"
                name="btnBack"
                class="btn btn-footer btn-primary"
                @click="onBack"
              >
                戻る
              </button>
              <button
                type="button"
                name="btnFixed"
                class="btn btn-footer btn-primary"
                @click="onFixed"
              >
                <template v-if="isEditModeUpdate">更新</template>
                <template v-else>登録</template>
              </button>
            </td>
          </tbody>
        </table>
        <ContentsPreviewComponent
          v-if="isInitComplete"
          :isOpen="isOpenPreviewModal"
          :categoryId="modalParamValueCategoryId"
          :contentsId="modalParamValueContentsId"
          @closePreview="handlePreviewModalClosed"
        />
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, PropType, computed } from "vue";
import * as tus from "tus-js-client"; // * as tus を使ってインポート
import messages from "@/assets/messages.json";
import {
  formatMessage,
  sanitizeInput,
  hasNoGaiji,
  scrollToTop,
  checkFileName,
  isTokenAlive,
  outputDebugLogs,
  commonHandleAxiosError,
  replaceInlineStyleWithClass,
  addInlineStyleToClass,
} from "@/Common";
import Modal from "../layout/TagsModalComponent.vue";
import { format } from "date-fns";
import { useRouter, useRoute } from "vue-router";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import { useProcessingStore } from "../../store/useProcessingStore";
import apiAuthClient from "@/util/apiClientAuth";
import { AppConstants } from "@/constants/AppConstants";
import { AxiosResponse } from "axios";
import QuillEditor from "../controls/QuillEditor.vue";
import { goBackToPreviousUrl } from "@/router";
import BackToTop from "../controls/BackToTop.vue";
import ContentsPreviewComponent from "../layout/ContentsPreviewComponent.vue";
import { useUserStore } from "@/store/userStore";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

interface Tag {
  tagId: string;
  tagName: string;
  selected: boolean;
}

interface SubCategory {
  subCategoryId: string;
  subCategoryName: string;
}

interface AgSegment {
  agSegmentCode: string;
  agSegmentName: string;
}

interface Skilup {
  skilupId: string;
  skilupName: string;
}

interface Phase {
  skilupId: string;
  phaseId: string;
  phaseName: string;
}

interface PhaseItem {
  phaseId: string;
  phaseName: string;
}

interface ThumbNail {
  thumbnailId: string;
  thumbnailName: string;
  thumbnailFileName: string;
}

interface ContentsData {
  contentsId: string; // コンテンツID
  subCategoryId: string; // サブカテゴリID
  title: string; // タイトル
  body: string; // 本文
  keisaiKikanStart: string; // 掲載期間FROM
  keisaiKikanEnd: string; // 掲載期間TO
  jyuyoFlg: boolean; // 重要フラグ
  jyuyoKikanStart: string; // 重要期間FROM
  jyuyoKikanEnd: string; // 重要期間TO
  lastUpdate: string; // 最終更新日付
  hyojiTaisho: string; // 表示対象
  agSegmentId: string; // エージェントセグメント
  agCode: string; // AGコード
  agCodeList: string[]; // AGコードリスト
  contentsLinkList: ContentsLink[]; // コンテンツリンクリスト
  contentsTempFileList: ContentsFile[]; // 添付ファイルリスト
  contentsImgList: ContentsFile[]; // 画像ファイルリスト
  contentsVideoList: ContentsFile[]; // 動画ファイルリスト
  contentsTempFileExp: string; // 添付ファイル説明
  contentsImgFileExp: string; // 画像ファイル説明
  contentsVideoFileExp: string; // 動画ファイル説明
  kensakuTagList: Tag[]; // 検索用タグ
  kanriTag: string; // 管理用タグ
  skilupId: string; // スキルアップID
  phaseId: string; // フェーズID
  thumbnailFileList: ContentsFile[]; // サムネイル画像ファイルリスト
  thumbnailFile: string;
}

// コンテンツリンクのinterface
interface ContentsLink {
  rowNo: number;
  caption: string;
  url: string;
}

// 添付ファイルのinterface
interface ContentsFile {
  rowNo: number;
  fileName: string;
  file: File | null;
  fileUrl: string | null;
  isUpload: boolean;
}

//
interface InitialDisplayData {
  subCategoryList: SubCategory[];
  agSegmentList: AgSegment[];
  kensakuTagList: Tag[];
  keisaiKikanStart: string;
  keisaiKikanEnd: string;
  lastUpdate: string;
  maxFileSize: string;
  skilupList: Skilup[];
  phaseList: Phase[];
  thumbNailList: ThumbNail[];
}

class ContentRegConstants {
  // API-URL
  static readonly API_URL_INITIAL_DISPLAY =
    "/api/SkilupReg/getInitialDisplayData";
  static readonly API_URL_GET_CONTENTS = "/api/SkilupReg/getContents";
  static readonly API_URL_CREATE = "/api/SkilupReg/RegContents";
  static readonly API_URL_UPDATE = "/api/SkilupReg/UpdateContents";
  static readonly API_URL_DELETE = "/api/SkilupReg/DeleteContents";

  // 表示対象
  static readonly HYOJI_TAISHO_ALL = "0"; // ALL
  static readonly HYOJI_TAISHO_AG_SEGMENT = "1"; // AGセグメント
  static readonly HYOJI_TAISHO_AG_CODE = "2"; // AGコード

  // イベント発火元
  static readonly TRIGGER_TEMP_FILE = "tempFile"; // 添付ファイル
  static readonly TRIGGER_IMG_FILE = "imgFile"; // 画像ファイル
  static readonly TRIGGER_VIDEO_FILE = "videoFile"; // 動画ファイル
  static readonly TRIGGER_THUMBNAIL_FILE = "thumbnailFile"; // 動画ファイル
}

export default defineComponent({
  name: "SkilupRegComponent",
  props: {
    categoryId: {
      type: String as PropType<string>,
    },
    contentsId: {
      type: String as PropType<string>,
    },
    editMode: {
      type: String as PropType<string>,
    },
  },
  components: {
    HeaderComponent,
    FooterComponent,
    Modal,
    QuillEditor,
    BackToTop,
    ContentsPreviewComponent,
    LoadingOverlay,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const paramContentsCategoryId = computed(
      () => route.query.categoryId as string
    ); // パラメータ．コンテンツカテゴリID
    const paramContentsId = computed(() => route.query.contentsId as string); // パラメータ．コンテンツID
    const paramEditMode = computed(() => route.query.editMode as string); // パラメータ．編集モード
    const { getCategoryNeme, getCategoryIdByName, getCategoryURL } =
      useUserParmitionStore();
    const processingStore = useProcessingStore();
    const errorMessage = ref(""); // エラーメッセージ
    const agCode = ref(""); // ローカルストレージ．AGコード
    const userId = ref(""); // ローカルストレージ．ユーザーID
    const categoryId = ref<string | null>(null);
    const contentsCaategoryName = ref<string | null>(null); // コンテンツカテゴリ名
    const subCategoryList = ref<SubCategory[]>([]); // サブカテゴリリスト
    const tags = ref<Tag[]>([]); // タグリスト
    const agSegmentList = ref<AgSegment[]>([]); // AGセグメントリスト
    const isInitComplete = ref(false); // 初期表示完了フラグ
    const isInitError = ref(false); // 初期表示時のエラーフラグ
    const isContentsDeleted = ref(false); // コンテンツ削除フラグ
    const { logoutUser } = useUserStore();
    const skilupList = ref<Skilup[]>([]); // スキルアップリスト
    const phaseList = ref<Phase[]>([]); // フェーズリスト
    const selectedSkilupPhaseList = ref<PhaseItem[]>([]); //選択されたスキルアップに紐づくフェーズリスト
    const thumbNailList = ref<ThumbNail[]>([]); // フェーズリスト
    const isDataFetched = ref(false); // 初期表示データが取得済みかどうかを追跡
    const isLoading = ref(false);
    const copyContentsId = ref(""); // コピー元のコンテンツID

    // コンテンツデータ
    const contentsData = ref<ContentsData>({
      contentsId: "", // コンテンツID
      subCategoryId: "", // サブカテゴリID
      title: "", // タイトル
      body: AppConstants.QuillEditor_EMPTY, // 本文
      keisaiKikanStart: "", // 掲載期間FROM
      keisaiKikanEnd: "", // 掲載期間TO
      jyuyoFlg: false, // 重要フラグ
      jyuyoKikanStart: "", // 重要期間FROM
      jyuyoKikanEnd: "", // 重要期間TO
      lastUpdate: "", // 最終更新日付
      hyojiTaisho: ContentRegConstants.HYOJI_TAISHO_ALL, // 表示対象
      agSegmentId: "", // エージェントセグメント
      agCode: "", // AGコード
      agCodeList: [], // AGコードリスト
      contentsLinkList: [
        { rowNo: 1, caption: "", url: "" },
        { rowNo: 2, caption: "", url: "" },
        { rowNo: 3, caption: "", url: "" },
      ], // コンテンツリンクリスト
      contentsTempFileList: [], // 添付ファイルリスト
      contentsImgList: [], // 画像ファイルリスト
      contentsVideoList: [], // 動画ファイルリスト
      contentsTempFileExp: "", // 添付ファイル説明
      contentsImgFileExp: "", // 画像ファイル説明
      contentsVideoFileExp: "", // 動画ファイル説明
      kensakuTagList: [], // 検索用タグ
      kanriTag: "", // 管理用タグ
      skilupId: "", // スキルアップID
      phaseId: "", // フェーズID
      thumbnailFileList: [], // サムネイル画像（アップロード用）
      thumbnailFile: "", // サムネイル画像
    });

    // アップロード
    const hyojiTaishoExtensions = [".csv"]; // 表示対象の拡張子
    const tempFileExtensions = [".pdf", ".docx", ".xlsx", ".txt", ".pptx"]; // 添付ファイルの拡張子
    const imgFileExtensions = [".jpg", ".png"]; // 画像ファイルの拡張子
    const videoFileExtensions = [".mp4", ".webm", ".ogv"]; // 動画ファイルの拡張子
    const thumbnailFileExtensions = [".jpg", ".png"]; // サムネイル画像ファイルの拡張子
    const uploadProgress = ref<number | null>(null); //
    let maxFileSize = 0; // ファイルアップロードの最大サイズ

    // 検索用タグモーダル
    const isOpenKensakuTagModal = ref(false); // 起動フラグ
    const kensakuTagModalodalTags = ref<Tag[]>([]); // タグリスト

    // 本文update処理
    const handleContentUpdate = (newContent: string) => {
      contentsData.value.body = newContent;
    };

    const cmbSubCategory = ref<HTMLSelectElement | null>(null);
    const agCodeFileInput = ref<HTMLInputElement | null>(null);

    // プレビューモーダル
    const isOpenPreviewModal = ref(false);
    const modalParamValueCategoryId = ref("");
    const modalParamValueContentsId = ref("");

    const initialDisplayData = ref<InitialDisplayData>({
      subCategoryList: [],
      agSegmentList: [],
      kensakuTagList: [],
      keisaiKikanStart: "",
      keisaiKikanEnd: "",
      lastUpdate: "",
      maxFileSize: "",
      skilupList: [],
      phaseList: [],
      thumbNailList: [],
    });

    // アップロード関連
    const tempFileInput = ref<HTMLInputElement | null>(null);
    const imgFileInput = ref<HTMLInputElement | null>(null);
    const videoFileInput = ref<HTMLInputElement | null>(null);
    const thumbnailFileInput = ref<HTMLInputElement | null>(null);
    let uploadTarget = ref("");

    // routerパラメータ退避用
    let contentsCategoryId = ref(""); // コンテンツカテゴリID
    let contentsId = ref(""); // コンテンツID
    let editMode = ref(""); // 編集モード

    // 初期処理
    onMounted(async () => {
      // routerパラメータを内部パラメータに設定
      contentsCategoryId.value = paramContentsCategoryId.value;
      contentsId.value = paramContentsId.value;
      editMode.value = paramEditMode.value;

      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agCode.value = parsedUserInfo.agCode;
        userId.value = parsedUserInfo.userId;
      }
      // カテゴリID取得
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_SKILUP_TOUROKU
      );
      // コンテンツカテゴリ名取得
      contentsCaategoryName.value = getCategoryNeme(contentsCategoryId.value);
      outputDebugLogs("コンテンツカテゴリID:" + contentsCategoryId.value);
      outputDebugLogs("コンテンツカテゴリ名:" + contentsCaategoryName.value);

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;
      try {
        // コンテンツ初期表示データ取得
        const response = await apiAuthClient.post(
          ContentRegConstants.API_URL_INITIAL_DISPLAY,
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
            categoryId: categoryId.value, // カテゴリID
            contentsCategoryId: contentsCategoryId.value, // コンテンツカテゴリID
          }
        );

        //
        initialDisplayData.value = response.data.initialDisplayData;
        // サブカテゴリコンボボックス設定
        subCategoryList.value =
          response.data.initialDisplayData.subCategoryList;
        // エージェントセグメントコンボボックス設定
        agSegmentList.value = initialDisplayData.value.agSegmentList;
        // タグ設定
        tags.value = initialDisplayData.value.kensakuTagList;
        // 掲載期間FROM
        contentsData.value.keisaiKikanStart = formatDate(
          initialDisplayData.value.keisaiKikanStart
        );
        // 掲載期間TO
        contentsData.value.keisaiKikanEnd = formatDate(
          initialDisplayData.value.keisaiKikanEnd
        );
        // 最終更新日付
        contentsData.value.lastUpdate = formatDate(
          initialDisplayData.value.lastUpdate
        );
        // ファイルアップロードの最大サイズ
        maxFileSize = parseInt(initialDisplayData.value.maxFileSize || "0", 10);

        // スキルアップ名コンボボックス設定
        skilupList.value = response.data.initialDisplayData.skilupNameList;

        // フェーズリストデータ設定
        phaseList.value = response.data.initialDisplayData.phaseList;

        // サムネイル画像リストデータ設定
        thumbNailList.value = response.data.initialDisplayData.thumbNailList;

        // 編集モードが更新または参照新規の場合
        if (isEditModeUpdate.value || isEditModeCopy.value) {
          // コンテンツデータ取得
          const response = await apiAuthClient.post(
            ContentRegConstants.API_URL_GET_CONTENTS,
            {
              systemKbn: process.env.VUE_APP_SYSTEM_KBN,
              agCode: agCode.value,
              userId: userId.value,
              categoryId: categoryId.value, // カテゴリID
              contentsId: contentsId.value,
              contentsCategoryId: contentsCategoryId.value, // コンテンツカテゴリID
            }
          );

          // レスポンス設定
          setResponseOutput(response);

          // プレビュー表示パラメータへ値設定
          modalParamValueCategoryId.value = contentsCategoryId.value;
          modalParamValueContentsId.value = contentsId.value;
        }

        // フォーカス設定
        if (cmbSubCategory.value) {
          cmbSubCategory.value.focus();
        }

        isInitError.value = false;
        isDataFetched.value = true;
      } catch (error: unknown) {
        // エラー時は初期表示エラーフラグをON
        isInitError.value = true;
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }

      isInitComplete.value = true;
    });

    /**
     * コンテンツデータ取得APIのレスポンス処理
     * @param response
     */
    const setResponseOutput = (response: AxiosResponse) => {
      const contents = response.data.contents;

      // レスポンスの日付フォーマット
      contents.keisaiKikanStart = formatDate(contents.keisaiKikanStart); // 掲載期間FROM
      contents.keisaiKikanEnd = formatDate(contents.keisaiKikanEnd); // 掲載期間TO
      contents.jyuyoKikanStart = formatDate(contents.jyuyoKikanStart); // 重要期間FROM
      contents.jyuyoKikanEnd = formatDate(contents.jyuyoKikanEnd); // 重要期間TO
      contents.lastUpdate = formatDate(contents.lastUpdate); // 最終更新日付

      outputDebugLogs("【 body 】:" + contents.body);
      // CSP対応によるunsafe-inlineの制限によって、style属性が含まれていると
      // エラーになるため、サーバーから送信される本文データの色の部分はclass属性になっている。
      // quillエディタで文字色を表示するために、class属性にstyle属性も追加している
      contents.body = addInlineStyleToClass(contents.body);
      outputDebugLogs("【 body addInlineStyleToClass 】:" + contents.body);
      // 表示対象コードリストを退避
      const hyojiTaishoCodeList = contents.hyojiTaishoCodeList;
      // 表示対象コードリストを削除
      delete contents.hyojiTaishoCodeList;

      // 管理用タグを退避
      const kanriTagList = contents.kanriTagList;
      // 管理用タグを削除
      delete contents.kanriTagList;

      // レスポンス設定
      contentsData.value = contents as ContentsData;

      // 表示対象を復元
      contentsData.value.agSegmentId = "";
      contentsData.value.agCode = "";
      contentsData.value.agCodeList = [];
      if (isHyojiTaishoAgSegment.value) {
        // AGセグメント
        contentsData.value.agSegmentId = hyojiTaishoCodeList[0];
      } else if (isHyojiTaishoAgCode.value) {
        // AGコード
        if (hyojiTaishoCodeList.length > 1) {
          contentsData.value.agCodeList = hyojiTaishoCodeList;
        } else {
          contentsData.value.agCode = hyojiTaishoCodeList[0];
        }
      }

      // 管理用タグを復元
      contentsData.value.kanriTag = kanriTagList
        .map((tag: Tag) => tag.tagName)
        .join(",");

      // タグリストを選択状態にする
      contentsData.value.kensakuTagList.forEach((tag1) => {
        const tag2 = tags.value.find((tag2) => tag1.tagId === tag2.tagId);
        if (tag2) {
          tag2.selected = true;
        }
      });

      // *** ↓スキルアップ関連↓ ***
      // スキルアップID
      contentsData.value.skilupId = contents.skilupId;

      if (contentsData.value.skilupId != "") {
        // スキルアップIDが設定されている場合は、フェーズリストを絞込
        onChangeSkilupList(contents.phaseId);
      }
      // フェーズID
      contentsData.value.phaseId = contents.phaseId;
      // サムネイル画像名
      contentsData.value.thumbnailFile = contents.tumbnailName;

      // *** ↑スキルアップ関連↑ ***

      // 参照新規の場合
      if (isEditModeCopy.value) {
        // コピー元のコンテンツIDを退避
        copyContentsId.value = contentsData.value.contentsId;
        // コンテンツIDをクリア
        contentsData.value.contentsId = "";
      }
    };

    /**
     * プレビューボタン押下
     */
    const onPreview = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      isOpenPreviewModal.value = true;
    };

    /**
     * プレビュー >> ダイアログ画面で戻る処理を実行
     */
    const handlePreviewModalClosed = async () => {
      isOpenPreviewModal.value = false;
    };

    /**
     * 戻るボタン押下
     */
    const onBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      if (isContentsDeleted.value) {
        // コンテンツを削除している場合
        // カテゴリIDからURLを取得して一覧に戻る
        const backUrl = getCategoryURL(contentsCategoryId.value);
        outputDebugLogs("【 contentsCategoryId 】:" + contentsCategoryId.value);
        outputDebugLogs("【 backUrl 】:" + backUrl);

        if (backUrl) {
          router.push(backUrl);
        } else {
          // カテゴリIDからURLが取得できなかった場合は共通の戻る処理
          goBackToPreviousUrl();
        }
      } else {
        // 上記以外
        goBackToPreviousUrl();
      }
    };

    /**
     * 削除ボタン押下
     */
    const onDelete = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // 確認ダイアログ表示
      const isConfirm = window.confirm(formatMessage(messages.CNF_0004));
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // メッセージクリア
      errorMessage.value = "";
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // コンテンツ詳細削除APIを実行;
        await apiAuthClient.post(ContentRegConstants.API_URL_DELETE, {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          agCode: agCode.value,
          userId: userId.value,
          categoryId: categoryId.value, // カテゴリID
          contentsId: contentsData.value.contentsId,
          contentsCategoryId: contentsCategoryId.value, // コンテンツカテゴリID
        });

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "データ", "削除"));

        // コンテンツ削除フラグON
        isContentsDeleted.value = true;
        // 新規登録可能な状態にする
        resetNew();
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 登録ボタン押下
     */
    const onFixed = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // メッセージクリア
      errorMessage.value = "";
      // 入力チェック
      if (!validateInput()) {
        scrollToTop();
        return;
      }

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // 確認ダイアログ表示
      const isConfirm = window.confirm(
        formatMessage(
          messages.CNF_0001,
          "データ",
          isEditModeUpdate.value ? "更新" : "登録"
        )
      );
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        let result = false;

        // ファイルアップロード
        // 添付ファイル
        result = await executeContentsFiles(
          contentsData.value.contentsTempFileList
        );

        if (result) {
          // 画像ファイル
          result = await executeContentsFiles(
            contentsData.value.contentsImgList
          );
        }

        if (result) {
          // 動画ファイル
          result = await executeContentsFiles(
            contentsData.value.contentsVideoList
          );
        }

        if (result) {
          // サムネイル画像ファイル
          result = await executeContentsFiles(
            contentsData.value.thumbnailFileList
          );
        }

        // ファイルアップロードに失敗している場合
        if (!result) {
          scrollToTop();
          errorMessage.value = formatMessage(
            messages.ERR_SYS003,
            "ファイルアップロード"
          );
          return;
        }

        if (result) {
          if (isEditModeUpdate.value) {
            // 更新処理
            await executeUpdate();
          } else {
            // 登録処理
            await executeCreate();
          }
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**
     * ファイルアップロード実行
     * @param contentsFileList
     */
    async function executeContentsFiles(contentsFileList: ContentsFile[]) {
      let result = true;

      for (const contentsFile of contentsFileList) {
        if (contentsFile.isUpload) {
          try {
            await uploadContentsFile(contentsFile);
          } catch (error) {
            result = false;
            break;
          }
        }
      }

      return result;
    }

    /**
     * 登録処理
     */
    const executeCreate = async () => {
      try {
        // コンテンツ詳細登録APIを実行
        const response = await apiAuthClient.post(
          ContentRegConstants.API_URL_CREATE,
          getRequestInput()
        );

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "データ", "登録"));

        // 確認ダイアログ表示
        const isConfirm = window.confirm(formatMessage(messages.CNF_0005));
        if (isConfirm) {
          // OKの場合

          // 新規登録可能な状態にする
          resetNew();
        } else {
          // キャンセルの場合

          // 編集モードを設定
          editMode.value = AppConstants.CONTENTS_EDIT_MODE_UPDATE;
          // コンテンツIDを設定
          contentsId.value = response.data.contentsId;
          // コンテンツデータ再取得
          await getContents();
        }
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 更新処理
     */
    const executeUpdate = async () => {
      try {
        outputDebugLogs("更新前本文:" + contentsData.value.body);

        // コンテンツ詳細更新APIを実行
        await apiAuthClient.post(
          ContentRegConstants.API_URL_UPDATE,
          getRequestInput()
        );

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "データ", "更新"));

        // コンテンツデータ再取得
        await getContents();
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 新規登録可能な状態にする
     */
    const resetNew = () => {
      // 新規登録モードを設定
      editMode.value = AppConstants.CONTENTS_EDIT_MODE_NEW;
      // 画面入力内容クリア
      contentsData.value = getContentsDataDef();
      // タグリスト
      tags.value.map((tag) => (tag.selected = false));
      // フォーカス設定
      if (cmbSubCategory.value) {
        cmbSubCategory.value.focus();
      }
      // スクロールを上部に移動
      scrollToTop();
    };

    /**
     * コンテンツデータ取得
     */
    const getContents = async () => {
      // コンテンツデータ取得
      isInitComplete.value = false;

      const response = await apiAuthClient.post(
        ContentRegConstants.API_URL_GET_CONTENTS,
        {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          agCode: agCode.value,
          userId: userId.value,
          categoryId: categoryId.value, // カテゴリID
          contentsId: contentsId.value,
          contentsCategoryId: contentsCategoryId.value, // コンテンツカテゴリID
        }
      );

      // レスポンス設定
      setResponseOutput(response);

      // フォーカス設定
      if (cmbSubCategory.value) {
        cmbSubCategory.value.focus();
      }
      // スクロールを上部に移動
      scrollToTop();

      // プレビュー表示パラメータへ値設定
      modalParamValueCategoryId.value = contentsCategoryId.value;
      modalParamValueContentsId.value = contentsId.value;

      isInitComplete.value = true;
    };

    /**
     * 登録・更新APIのリクエストデータを返却します。
     */
    const getRequestInput = (): object => {
      return {
        systemKbn: process.env.VUE_APP_SYSTEM_KBN,
        agCode: agCode.value,
        userId: userId.value,
        categoryId: categoryId.value, // カテゴリID
        contentsId: contentsData.value.contentsId, // コンテンツID
        contentsCategoryId: contentsCategoryId.value, // コンテンツカテゴリID
        subCategoryId: contentsData.value.subCategoryId, // サブカテゴリID
        title: sanitizeInput(contentsData.value.title), // タイトル
        // CSP対応によるunsafe-inlineの制限によって、style属性が含まれていると
        // エラーになるため、サーバーに送る前にstyle属性をclassに変換している
        body: replaceInlineStyleWithClass(
          sanitizeInput(contentsData.value.body)
        ), // 本文
        keisaiKikanStart: getValidStrDate(contentsData.value.keisaiKikanStart), // 掲載期間FROM
        keisaiKikanEnd: getValidStrDate(contentsData.value.keisaiKikanEnd), // 掲載期間TO
        jyuyoFlg: contentsData.value.jyuyoFlg, // 重要フラグ
        jyuyoKikanStart: getValidStrDate(contentsData.value.jyuyoKikanStart), // 重要期間FROM
        jyuyoKikanEnd: getValidStrDate(contentsData.value.jyuyoKikanEnd), // 重要期間TO
        lastUpdate: getValidStrDate(contentsData.value.lastUpdate), // 最終更新日付
        hyojiTaisho: contentsData.value.hyojiTaisho, // 表示対象
        hyojiTaishoCodeList: getHyojiTaishoCodeList(), // 表示対象コードリスト
        contentsLinkList: contentsData.value.contentsLinkList.map(
          (contentsLink) => ({
            rowNo: contentsLink.rowNo,
            caption: sanitizeInput(contentsLink.caption),
            url: sanitizeInput(contentsLink.url),
          })
        ), // コンテンツリンクリスト
        contentsTempFileList: contentsData.value.contentsTempFileList, // 添付ファイルリスト
        contentsImgList: contentsData.value.contentsImgList, // 画像ファイルリスト
        contentsVideoList: contentsData.value.contentsVideoList, // 動画ファイルリスト
        contentsTempFileExp: sanitizeInput(
          contentsData.value.contentsTempFileExp
        ), // 添付ファイル説明
        contentsImgFileExp: sanitizeInput(
          contentsData.value.contentsImgFileExp
        ), // 画像ファイル説明
        contentsVideoFileExp: sanitizeInput(
          contentsData.value.contentsVideoFileExp
        ), // 動画ファイル説明
        kensakuTagList: contentsData.value.kensakuTagList, // 検索用タグ
        kanriTagList: getKanriTagList(), // 管理用タグ
        skilupId: contentsData.value.skilupId, // スキルアップID
        phaseId: contentsData.value.phaseId, // フェーズID
        thumbnailFileList: contentsData.value.thumbnailFileList, // サムネイル画像リスト
        tumbnailName: getThumbNailFileName(), // サムネイル画像
        copyContentsId: copyContentsId.value, // コピー元のコンテンツID
      };
    };

    /**
     * 表示対象コードリストを返却します。
     */
    const getHyojiTaishoCodeList = (): string[] => {
      // 表示対象
      if (isHyojiTaishoAgSegment.value) {
        // AGセグメント
        return [contentsData.value.agSegmentId];
      } else if (isHyojiTaishoAgCode.value) {
        // AGコード
        if (contentsData.value.agCodeList.length > 0) {
          // アップロードされている場合
          return contentsData.value.agCodeList.map((agCode) =>
            sanitizeInput(agCode)
          );
        } else {
          // テキスト入力されている場合
          return [sanitizeInput(contentsData.value.agCode)];
        }
      }

      return [];
    };

    /**
     * 管理用タグを返却します。
     */
    const getKanriTagList = (): Tag[] => {
      if (!contentsData.value.kanriTag) {
        return [];
      }

      return contentsData.value.kanriTag
        .split(",")
        .filter((tagName) => tagName.trim() != "")
        .map((tagName) => ({
          tagId: "",
          tagName: sanitizeInput(tagName),
          selected: false,
        }));
    };

    /**
     * 入力チェック
     */
    const validateInput = (): boolean => {
      const messageList = ref<string[]>([]);

      // サブカテゴリ
      // 必須チェック
      if (!contentsData.value.subCategoryId) {
        messageList.value.push(
          formatMessage(messages.ERR_0003, "サブカテゴリ")
        );
      }

      // 掲載期間
      const keisaiKikanStart = contentsData.value.keisaiKikanStart;
      const keisaiKikanEnd = contentsData.value.keisaiKikanEnd;
      // 必須チェック
      if (!keisaiKikanStart) {
        messageList.value.push(
          formatMessage(messages.ERR_0001, "掲載期間FROM")
        );
      }
      if (!keisaiKikanEnd) {
        messageList.value.push(formatMessage(messages.ERR_0001, "掲載期間TO"));
      }
      // 大小チェック
      if (keisaiKikanStart && keisaiKikanEnd) {
        if (new Date(keisaiKikanStart) > new Date(keisaiKikanEnd)) {
          messageList.value.push(
            formatMessage(messages.ERR_0005, "掲載期間FROM", "掲載期間TO")
          );
        }
      }

      // 最終更新日付
      // 必須チェック
      if (!contentsData.value.lastUpdate) {
        messageList.value.push(
          formatMessage(messages.ERR_0001, "最終更新日付")
        );
      }

      // タイトル
      const sanitizedTitle = sanitizeInput(contentsData.value.title);
      // 必須チェック、使用不可文字チェック
      if (!sanitizedTitle) {
        messageList.value.push(formatMessage(messages.ERR_0001, "タイトル"));
      } else if (!hasNoGaiji(sanitizedTitle)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "タイトル"));
      }

      // 重要期間
      if (contentsData.value.jyuyoFlg) {
        const jyuyoKikanStart = contentsData.value.jyuyoKikanStart;
        const jyuyoKikanEnd = contentsData.value.jyuyoKikanEnd;
        // 必須チェック
        if (!jyuyoKikanStart) {
          messageList.value.push(
            formatMessage(messages.ERR_0001, "重要期間FROM")
          );
        }
        if (!jyuyoKikanEnd) {
          messageList.value.push(
            formatMessage(messages.ERR_0001, "重要期間TO")
          );
        }
        // 大小チェック
        if (jyuyoKikanStart && jyuyoKikanEnd) {
          if (new Date(jyuyoKikanStart) > new Date(jyuyoKikanEnd)) {
            messageList.value.push(
              formatMessage(messages.ERR_0005, "重要期間FROM", "重要期間TO")
            );
          }
        }
      }

      if (isHyojiTaishoAgSegment.value) {
        // エージェントセグメント

        // 必須チェック
        if (!contentsData.value.agSegmentId) {
          messageList.value.push(
            formatMessage(messages.ERR_0003, "エージェントセグメント")
          );
        }
      } else if (isHyojiTaishoAgCode.value) {
        // AGコード

        // 必須チェック、使用不可文字チェック
        if (
          !contentsData.value.agCode &&
          contentsData.value.agCodeList.length == 0
        ) {
          messageList.value.push(formatMessage(messages.ERR_0002, "AGコード"));
        } else if (contentsData.value.agCodeList.length > 0) {
          // アップロードされている場合
          if (
            contentsData.value.agCodeList.some((agCode) => {
              const sanitizedAgCode = sanitizeInput(agCode);
              return !hasNoGaiji(sanitizedAgCode);
            })
          ) {
            messageList.value.push(
              formatMessage(messages.ERR_0026, "AGコード")
            );
          }
        } else {
          // テキスト入力されている場合
          const sanitizedAgCode = sanitizeInput(contentsData.value.agCode);
          if (!hasNoGaiji(sanitizedAgCode)) {
            messageList.value.push(
              formatMessage(messages.ERR_0026, "AGコード")
            );
          }
        }
      }

      // 本文
      const sanitizeBody = sanitizeInput(contentsData.value.body);
      // 必須チェック、使用不可文字チェック
      if (
        !sanitizeBody ||
        contentsData.value.body == AppConstants.QuillEditor_EMPTY
      ) {
        messageList.value.push(formatMessage(messages.ERR_0001, "本文"));
      } else if (!hasNoGaiji(sanitizeBody)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "本文"));
      }

      // リンクキャプション、リンクURL
      contentsData.value.contentsLinkList.forEach((contentsLink, index) => {
        const num = index + 1;
        const sanitizedCaption = sanitizeInput(contentsLink.caption);
        const sanitizedUrl = sanitizeInput(contentsLink.url);

        // リンクキャプション
        // 使用不可文字チェック
        if (!hasNoGaiji(sanitizedCaption)) {
          messageList.value.push(
            formatMessage(messages.ERR_0026, "リンクキャプション" + num)
          );
        }

        // リンクURL
        // 入力チェック、使用不可文字チェック
        if (sanitizedCaption && !sanitizedUrl) {
          messageList.value.push(
            formatMessage(messages.ERR_0002, "リンクURL" + num)
          );
        } else if (!hasNoGaiji(sanitizedUrl)) {
          messageList.value.push(
            formatMessage(messages.ERR_0026, "リンクURL" + num)
          );
        }
      });

      // 添付ファイル
      contentsData.value.contentsTempFileList
        .filter((contentsFile) => contentsFile.file != null)
        .forEach((contentsFile) => {
          // ファイルチェック
          validateContentsFile(
            messageList.value,
            contentsFile,
            ContentRegConstants.TRIGGER_TEMP_FILE
          );
        });

      // 画像ファイル
      contentsData.value.contentsImgList
        .filter((contentsFile) => contentsFile.file != null)
        .forEach((contentsFile) => {
          // ファイルチェック
          validateContentsFile(
            messageList.value,
            contentsFile,
            ContentRegConstants.TRIGGER_IMG_FILE
          );
        });

      // 動画ファイル
      contentsData.value.contentsVideoList
        .filter((contentsFile) => contentsFile.file != null)
        .forEach((contentsFile) => {
          // ファイルチェック
          validateContentsFile(
            messageList.value,
            contentsFile,
            ContentRegConstants.TRIGGER_VIDEO_FILE
          );
        });

      // 添付ファイル説明
      const sanitizedContentsTempFileExp = sanitizeInput(
        contentsData.value.contentsTempFileExp
      );
      // 使用不可文字チェック
      if (!hasNoGaiji(sanitizedContentsTempFileExp)) {
        messageList.value.push(
          formatMessage(messages.ERR_0026, "添付ファイル説明")
        );
      }

      // 画像ファイル説明
      const sanitizedContentsImgFileExp = sanitizeInput(
        contentsData.value.contentsImgFileExp
      );
      // 使用不可文字チェック
      if (!hasNoGaiji(sanitizedContentsImgFileExp)) {
        messageList.value.push(
          formatMessage(messages.ERR_0026, "画像ファイル説明")
        );
      }

      // 動画ファイル説明
      const sanitizedContentsVideoFileExp = sanitizeInput(
        contentsData.value.contentsVideoFileExp
      );
      // 使用不可文字チェック
      if (!hasNoGaiji(sanitizedContentsVideoFileExp)) {
        messageList.value.push(
          formatMessage(messages.ERR_0026, "動画ファイル説明")
        );
      }

      // 検索用タグ
      // 必須チェック
      if (contentsData.value.kensakuTagList.length == 0) {
        messageList.value.push(formatMessage(messages.ERR_0003, "検索用タグ"));
      }

      // 管理用タグ
      // 使用不可文字チェック
      if (
        getKanriTagList().some((tags) => {
          return !hasNoGaiji(tags.tagName);
        })
      ) {
        messageList.value.push(formatMessage(messages.ERR_0026, "管理用タグ"));
      }

      // スキルアップ名
      // 必須チェック
      if (!contentsData.value.skilupId) {
        messageList.value.push(
          formatMessage(messages.ERR_0003, "スキルアップ名")
        );
      }

      // フェーズ
      // 必須チェック
      if (!contentsData.value.phaseId) {
        messageList.value.push(formatMessage(messages.ERR_0003, "フェーズ"));
      }

      // サムネイル画像
      contentsData.value.thumbnailFileList
        .filter((contentsFile) => contentsFile.file != null)
        .forEach((contentsFile) => {
          // ファイルチェック
          validateContentsFile(
            messageList.value,
            contentsFile,
            ContentRegConstants.TRIGGER_THUMBNAIL_FILE
          );
        });

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**
     * ファイルチェック
     * @param contentsFile
     */
    const validateContentsFile = (
      messageList: string[],
      contentsFile: ContentsFile,
      trigger: string
    ): boolean => {
      let isErr = false;

      // ファイルサイズチェック
      if (!isFileSize(contentsFile.file)) {
        messageList.push(
          (errorMessage.value = formatMessage(
            messages.ERR_0024,
            maxFileSize / (1024 * 1024)
          ))
        );
        isErr = true;
      }

      // イベントの発火元により処理を分岐
      switch (trigger) {
        case ContentRegConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル

          if (!isFileExtensions(contentsFile.file, ...tempFileExtensions)) {
            // 拡張子チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0027,
                "添付ファイル"
              ))
            );
            isErr = false;
          } else if (
            !isFilenameDuplicate(
              contentsFile,
              contentsData.value.contentsTempFileList
            )
          ) {
            // ファイル名重複チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0017,
                "添付ファイル名"
              ))
            );
            isErr = false;
          } else if (!checkFileName(contentsFile.fileName.toLowerCase())) {
            // ファイル名チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0025,
                "添付ファイル名"
              ))
            );
            isErr = false;
          }
          break;
        case ContentRegConstants.TRIGGER_IMG_FILE:
          // 画像ファイル

          // 拡張子チェック
          if (!isFileExtensions(contentsFile.file, ...imgFileExtensions)) {
            // 拡張子チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0027,
                "画像ファイル"
              ))
            );
            isErr = false;
          } else if (
            !isFilenameDuplicate(
              contentsFile,
              contentsData.value.contentsImgList
            )
          ) {
            // ファイル名重複チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0017,
                "画像ファイル名"
              ))
            );
            isErr = false;
          } else if (!checkFileName(contentsFile.fileName.toLowerCase())) {
            // ファイル名チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0025,
                "画像ファイル名"
              ))
            );
            isErr = false;
          }
          break;

        case ContentRegConstants.TRIGGER_VIDEO_FILE:
          // 動画ファイル

          if (!isFileExtensions(contentsFile.file, ...videoFileExtensions)) {
            // 拡張子チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0027,
                "動画ファイル"
              ))
            );
            isErr = false;
          } else if (
            !isFilenameDuplicate(
              contentsFile,
              contentsData.value.contentsVideoList
            )
          ) {
            // ファイル名重複チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0017,
                "動画ファイル名"
              ))
            );
            isErr = false;
          } else if (!checkFileName(contentsFile.fileName.toLowerCase())) {
            // ファイル名チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0025,
                "動画ファイル名"
              ))
            );
            isErr = false;
          }
          break;
        case ContentRegConstants.TRIGGER_THUMBNAIL_FILE:
          // 画像ファイル

          // 拡張子チェック
          if (
            !isFileExtensions(contentsFile.file, ...thumbnailFileExtensions)
          ) {
            // 拡張子チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0027,
                "サムネイル画像ファイル"
              ))
            );
            isErr = false;
          } else if (
            !isFilenameDuplicate(
              contentsFile,
              contentsData.value.contentsImgList
            )
          ) {
            // ファイル名重複チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0017,
                "サムネイル画像ファイル名"
              ))
            );
            isErr = false;
          } else if (!checkFileName(contentsFile.fileName.toLowerCase())) {
            // ファイル名チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0025,
                "サムネイル画像ファイル名"
              ))
            );
            isErr = false;
          }
          break;
      }
      return !isErr;
    };

    /**
     * ファイルサイズチェック
     */
    const isFileSize = (file: File | null): boolean => {
      return (file?.size ?? 0) <= maxFileSize;
    };

    /**
     * ファイル拡張子チェック
     * @param file ファイル
     * @param extensions 拡張子
     */
    const isFileExtensions = (
      file: File | null,
      ...extensions: string[]
    ): boolean => {
      return extensions.some((extension) =>
        file?.name.toLowerCase().endsWith(extension)
      );
    };

    /**
     * ファイル名重複チェック
     * @param file ファイル
     * @param extensions 拡張子
     */
    const isFilenameDuplicate = (
      target: ContentsFile,
      contentsListFile: ContentsFile[]
    ): boolean => {
      return !contentsListFile
        .filter((contentsFile) => contentsFile.rowNo != target.rowNo)
        .some((contentsFile) => contentsFile.fileName == target.fileName);
    };

    /**
     * ファイルアップロード処理
     * @param item
     */
    const uploadContentsFile = (contentsFile: ContentsFile): Promise<void> => {
      return new Promise((resolve, reject) => {
        if (!contentsFile.file) {
          reject("No file selected");
          return;
        }

        // ローカルストレージからトークンを取得
        const token = localStorage.getItem(AppConstants.TOKEN_SESSION_NAME);
        if (!token) {
          reject("No token found. Please log in.");
          return;
        }

        const upload = new tus.Upload(contentsFile.file, {
          // ファイルアップロードのエンドポイント
          endpoint: process.env.VUE_APP_FILE_UPLOAD_ENDPOINT,
          headers: {
            Authorization: `Bearer ${token}`,
          },
          metadata: {
            filename: contentsFile.file.name,
            filetype: contentsFile.file.type,
            agcode: agCode.value,
            userid: userId.value,
          },
          onError: (error) => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.error("Upload failed:", error);
            }
            reject(error);
          },
          onProgress: (bytesUploaded, bytesTotal) => {
            uploadProgress.value = Math.floor(
              (bytesUploaded / bytesTotal) * 100
            );
          },
          onSuccess: () => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.log("Upload finished:", upload.url);
            }
            // ファイルURLを保存
            contentsFile.fileUrl = upload.url;
            resolve();
          },
        });

        upload.start();
      });
    };

    /**
     * 検索用タグ設定モーダル起動
     */
    const openKensakuTagModal = () => {
      kensakuTagModalodalTags.value = tags.value.map((tag) => ({ ...tag }));
      isOpenKensakuTagModal.value = true;
    };

    /**
     * 検索用タグ設定モーダル終了
     */
    const closeKensakuTagModal = () => {
      isOpenKensakuTagModal.value = false;
    };

    /**
     *
     * @param updatedTags
     */
    const updateKensakuTags = (updatedTags: Tag[]) => {
      tags.value = updatedTags;
      // 選択されたタグをフィルタリングして検索用タグに設定
      contentsData.value.kensakuTagList = tags.value.filter(
        (tag) => tag.selected
      );
    };

    /**
     * 検索用タグを画面表示用に編集して返却します。
     */
    const getValueKensakuTag = computed(() => {
      return contentsData.value.kensakuTagList
        .map((tag) => {
          return [tag["tagName"]];
        })
        .join(",");
    });

    /**
     * 表示対象ラジオ変更時
     */
    const onChangeHyojiTaisho = () => {
      contentsData.value.agSegmentId = "";
      contentsData.value.agCode = "";
      contentsData.value.agCodeList = [];
    };

    /**
     * アップロードボタン押下時
     */
    const onAgCodeFileUpload = () => {
      // ファイル選択イベント発火
      if (agCodeFileInput.value) {
        agCodeFileInput.value.click();
      }
    };

    /**
     * 表示対象アップロード時
     */
    const handleAgCodeFileUpload = (event: Event) => {
      if (processingStore.isProcessing) {
        return;
      }

      // メッセージクリア
      errorMessage.value = "";
      contentsData.value.agCode = "";
      contentsData.value.agCodeList = [];
      // 処理中フラグON
      processingStore.isProcessing = true;
      //
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];

      try {
        if (file) {
          // 拡張子のチェック
          if (!isFileExtensions(file, ...hyojiTaishoExtensions)) {
            errorMessage.value = formatMessage(messages.ERR_0010);
            scrollToTop();
            return;
          }

          // ファイル名のチェック
          if (!checkFileName(file.name.toLowerCase())) {
            errorMessage.value = formatMessage(messages.ERR_0025, "ファイル名");
            scrollToTop();
            return;
          }

          // ファイルの内容を読み込み、行数をチェック
          const reader = new FileReader();
          reader.onload = () => {
            const text = reader.result as string;
            const lines = text.split(/\r\n|\n/);
            // 行数が0件かどうかをチェック
            if (lines.length === 0 || (lines.length === 1 && lines[0] === "")) {
              errorMessage.value = formatMessage(messages.ERR_0011);
              scrollToTop();
              return;
            }
            // 表示対象コードリストに設定
            contentsData.value.agCodeList = lines
              .filter((item) => item.trim() != "") // 空白行を除外
              .map((item) => item.replace(/^"(.*)"$/, "$1")); // 前後のダブルクォーテーションを削除
          };
          reader.readAsText(file);
        }
      } finally {
        // ファイルを未選択状態にする
        fileInput.value = "";
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 表示対象のアップロード件数を返却します。
     */
    const getValueAgCodeUploadCnt = computed(() => {
      return (
        Intl.NumberFormat("en-US").format(
          contentsData.value.agCodeList.length
        ) + "件"
      );
    });

    /**
     * 添付ファイルアップロードボタン押下時
     * @param trigger
     */
    const onContentsFileUpload = (trigger: string) => {
      // イベントの発火元を保存
      uploadTarget.value = trigger;

      // イベントの発火元により処理を分岐
      switch (trigger) {
        case ContentRegConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル
          if (tempFileInput.value) {
            tempFileInput.value.click();
          }
          break;
        case ContentRegConstants.TRIGGER_IMG_FILE:
          // 画像ファイル
          if (imgFileInput.value) {
            imgFileInput.value.click();
          }
          break;
        case ContentRegConstants.TRIGGER_VIDEO_FILE:
          // 動画ファイル
          if (videoFileInput.value) {
            videoFileInput.value.click();
          }
          break;
        case ContentRegConstants.TRIGGER_THUMBNAIL_FILE:
          // サムネイル画像ファイル
          if (thumbnailFileInput.value) {
            thumbnailFileInput.value.click();
          }
          break;
      }
    };

    /**
     * 添付ファイル選択時
     * @param event
     */
    const handleContentsFileSelected = (event: Event) => {
      contentsFileSelected(event, uploadTarget.value);
    };

    /**
     * 添付ファイル選択時
     * @param event
     * @param trigger
     */
    const contentsFileSelected = (event: Event, trigger: string) => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      errorMessage.value = "";

      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];

      try {
        if (file) {
          const contentsFile = {
            rowNo: getContentsFileMaxRowNo(trigger) + 1,
            fileName: file.name,
            file: file,
            fileUrl: null,
            isUpload: true,
          };

          // ファイルサイズチェック
          if (!isFileSize(contentsFile.file)) {
            errorMessage.value = formatMessage(
              messages.ERR_0024,
              maxFileSize / (1024 * 1024)
            );
            scrollToTop();
            return;
          }

          let messageId = "";
          let arg = "";

          // イベントの発火元により処理を分岐
          switch (trigger) {
            case ContentRegConstants.TRIGGER_TEMP_FILE:
              // 添付ファイル

              if (!isFileExtensions(contentsFile.file, ...tempFileExtensions)) {
                // 拡張子チェック
                messageId = messages.ERR_0027;
                arg = "添付ファイル";
              } else if (
                !isFilenameDuplicate(
                  contentsFile,
                  contentsData.value.contentsTempFileList
                )
              ) {
                // ファイル名重複チェック
                messageId = messages.ERR_0017;
                arg = "添付ファイル名";
              } else if (!checkFileName(file.name.toLowerCase())) {
                // ファイル名チェック
                messageId = messages.ERR_0025;
                arg = "添付ファイル名";
              }

              // エラーがある場合
              if (messageId) {
                errorMessage.value = formatMessage(messageId, arg);
                scrollToTop();
                return;
              }

              contentsData.value.contentsTempFileList.push(contentsFile);
              break;
            case ContentRegConstants.TRIGGER_IMG_FILE:
              // 画像ファイル

              if (!isFileExtensions(contentsFile.file, ...imgFileExtensions)) {
                // 拡張子チェック
                messageId = messages.ERR_0027;
                arg = "画像ファイル";
              } else if (
                !isFilenameDuplicate(
                  contentsFile,
                  contentsData.value.contentsImgList
                )
              ) {
                // ファイル名重複チェック
                messageId = messages.ERR_0017;
                arg = "画像ファイル名";
              } else if (!checkFileName(file.name.toLowerCase())) {
                // ファイル名チェック
                messageId = messages.ERR_0025;
                arg = "画像ファイル名";
              }

              // エラーがある場合
              if (messageId) {
                errorMessage.value = formatMessage(messageId, arg);
                scrollToTop();
                return;
              }

              contentsData.value.contentsImgList.push(contentsFile);
              break;

            case ContentRegConstants.TRIGGER_VIDEO_FILE:
              // 動画ファイル

              if (
                !isFileExtensions(contentsFile.file, ...videoFileExtensions)
              ) {
                // 拡張子チェック
                messageId = messages.ERR_0027;
                arg = "動画ファイル";
              } else if (
                !isFilenameDuplicate(
                  contentsFile,
                  contentsData.value.contentsVideoList
                )
              ) {
                // ファイル名重複チェック
                messageId = messages.ERR_0017;
                arg = "動画ファイル名";
              } else if (!checkFileName(file.name.toLowerCase())) {
                // ファイル名チェック
                messageId = messages.ERR_0025;
                arg = "動画ファイル名";
              }

              // エラーがある場合
              if (messageId) {
                errorMessage.value = formatMessage(messageId, arg);
                scrollToTop();
                return;
              }

              contentsData.value.contentsVideoList.push(contentsFile);
              break;
            case ContentRegConstants.TRIGGER_THUMBNAIL_FILE:
              // サムネイル画像ファイル
              if (
                !isFileExtensions(contentsFile.file, ...thumbnailFileExtensions)
              ) {
                // 拡張子チェック
                messageId = messages.ERR_0027;
                arg = "画像ファイル";
              } else if (!checkFileName(file.name.toLowerCase())) {
                // ファイル名チェック
                messageId = messages.ERR_0025;
                arg = "画像ファイル名";
              }

              // エラーがある場合
              if (messageId) {
                errorMessage.value = formatMessage(messageId, arg);
                scrollToTop();
                return;
              }

              contentsData.value.thumbnailFileList.push(contentsFile);
              contentsData.value.thumbnailFile = contentsFile.fileName;
              //selectedThumbnailFile.value = (contentsFile);
              break;
          }
        }
      } finally {
        // ファイルを未選択状態にする
        fileInput.value = "";
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * コンテンツファイルの最大値の行番号を返却します。
     */
    const getContentsFileMaxRowNo = (trigger: string): number => {
      let contentsFileList: ContentsFile[] = [];
      switch (trigger) {
        case ContentRegConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル
          contentsFileList = contentsData.value.contentsTempFileList;
          break;

        case ContentRegConstants.TRIGGER_IMG_FILE:
          // 画像ファイル
          contentsFileList = contentsData.value.contentsImgList;
          break;

        case ContentRegConstants.TRIGGER_VIDEO_FILE:
          // 動画ファイル
          contentsFileList = contentsData.value.contentsVideoList;
          break;
      }

      if (contentsFileList.length < 1) {
        return 0;
      }
      return Math.max.apply(
        null,
        contentsFileList.map(function (contentsFile) {
          return contentsFile.rowNo;
        })
      );
    };

    /**
     * コンテンツファイル削除
     * @param rowNo 行番号
     * @param trigger イベント発火元
     */
    const onRemoveContentsFile = (rowNo: number, trigger: string) => {
      switch (trigger) {
        case ContentRegConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル
          contentsData.value.contentsTempFileList =
            contentsData.value.contentsTempFileList.filter(
              (contentsFile) => contentsFile.rowNo != rowNo
            );
          // 添付ファイルが0件の場合
          if (!hasContentsTempFile.value) {
            // 添付ファイル説明クリア
            contentsData.value.contentsTempFileExp = "";
          }
          break;
        case ContentRegConstants.TRIGGER_IMG_FILE:
          // 画像ファイル
          contentsData.value.contentsImgList =
            contentsData.value.contentsImgList.filter(
              (contentsFile) => contentsFile.rowNo != rowNo
            );
          // 画像ファイルが0件の場合
          if (!hasContentsImgFile.value) {
            // 画像ファイル説明クリア
            contentsData.value.contentsImgFileExp = "";
          }
          break;
        case ContentRegConstants.TRIGGER_VIDEO_FILE:
          // 動画ファイル
          contentsData.value.contentsVideoList =
            contentsData.value.contentsVideoList.filter(
              (contentsFile) => contentsFile.rowNo != rowNo
            );
          // 動画ファイルが0件の場合
          if (!hasContentsVideoFile.value) {
            // 動画ファイル説明クリア
            contentsData.value.contentsVideoFileExp = "";
          }
          break;
      }
    };

    /**
     * 日付が有効な場合は日付、無効な場合はnullを返却します。
     */
    const getValidStrDate = (strDate: string): string | null => {
      if (strDate) {
        return strDate;
      }
      return null;
    };

    /**
     * サーバー日付をフォーマットします。
     */
    const formatDate = (strDate: string): string => {
      if (strDate) {
        return format(strDate, "yyyy-MM-dd");
      }
      return "";
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, true);
      scrollToTop();
    };

    /**
     * サムネイル画像名取得
     */
    const getThumbNailFileName = (): string => {
      if (contentsData.value.thumbnailFile == "") {
        return thumbNailList.value[0].thumbnailFileName;
      } else {
        return contentsData.value.thumbnailFile;
      }
    };

    /**
     * コンテンツデータの初期値を返却します。
     */
    const getContentsDataDef = (): ContentsData => {
      return {
        contentsId: "", // コンテンツID
        subCategoryId: "", // サブカテゴリID
        title: "", // タイトル
        body: AppConstants.QuillEditor_EMPTY, // 本文
        keisaiKikanStart: formatDate(initialDisplayData.value.keisaiKikanStart), // 掲載期間FROM
        keisaiKikanEnd: formatDate(initialDisplayData.value.keisaiKikanEnd), // 掲載期間TO
        jyuyoFlg: false, // 重要フラグ
        jyuyoKikanStart: "", // 重要期間FROM
        jyuyoKikanEnd: "", // 重要期間TO
        lastUpdate: formatDate(initialDisplayData.value.lastUpdate), // 最終更新日付
        hyojiTaisho: ContentRegConstants.HYOJI_TAISHO_ALL, // 表示対象
        agSegmentId: "", // エージェントセグメント
        agCode: "", // AGコード
        agCodeList: [], // AGコードリスト
        contentsLinkList: [
          { rowNo: 1, caption: "", url: "" },
          { rowNo: 2, caption: "", url: "" },
          { rowNo: 3, caption: "", url: "" },
        ], // コンテンツリンクリスト
        contentsTempFileList: [], // 添付ファイルリスト
        contentsImgList: [], // 画像ファイルリスト
        contentsVideoList: [], // 動画ファイルリスト
        contentsTempFileExp: "", // 添付ファイル説明
        contentsImgFileExp: "", // 画像ファイル説明
        contentsVideoFileExp: "", // 動画ファイル説明
        kensakuTagList: [], // 検索用タグ
        kanriTag: "", // 管理用タグ
        skilupId: "", // スキルアップID
        phaseId: "", // フェーズID
        thumbnailFileList: [], // サムネイル画像名
        thumbnailFile: "", // サムネイル画像
      };
    };

    /**
     * 編集モードUPDATE判定
     */
    const isEditModeUpdate = computed(() => {
      return editMode.value == AppConstants.CONTENTS_EDIT_MODE_UPDATE;
    });

    /**
     * 編集モードCOPY判定
     */
    const isEditModeCopy = computed(() => {
      return editMode.value == AppConstants.CONTENTS_EDIT_MODE_COPY;
    });

    /**
     * 表示対象ALL判定
     */
    const isHyojiTaishoAll = computed(() => {
      return (
        contentsData.value.hyojiTaisho == ContentRegConstants.HYOJI_TAISHO_ALL
      );
    });

    /**
     * 表示対象AG_SEGMENT判定
     */
    const isHyojiTaishoAgSegment = computed(() => {
      return (
        contentsData.value.hyojiTaisho ==
        ContentRegConstants.HYOJI_TAISHO_AG_SEGMENT
      );
    });

    /**
     * 表示対象AG_CODE判定
     */
    const isHyojiTaishoAgCode = computed(() => {
      return (
        contentsData.value.hyojiTaisho ==
        ContentRegConstants.HYOJI_TAISHO_AG_CODE
      );
    });

    /**
     * コンテンツ画像ファイルアップロード判定
     */
    const hasContentsTempFile = computed(() => {
      return contentsData.value.contentsTempFileList.length > 0;
    });

    /**
     * コンテンツ添付ファイルアップロード判定
     */
    const hasContentsImgFile = computed(() => {
      return contentsData.value.contentsImgList.length > 0;
    });

    /**
     * コンテンツ動画ファイルアップロード判定
     */
    const hasContentsVideoFile = computed(() => {
      return contentsData.value.contentsVideoList.length > 0;
    });

    /**
     * スキルアップ名リスト変更時
     */
    const onChangeSkilupList = (phaseId: string) => {
      selectedSkilupPhaseList.value = [];
      // 一旦フェーズIDをクリア
      contentsData.value.phaseId = "";
      console.log("contentsData.value.skilupId:", contentsData.value.skilupId);
      // 選択されたスキルアップIDに紐づくフェーズリストを抽出
      selectedSkilupPhaseList.value = phaseList.value.filter(
        (phaseList) => phaseList.skilupId === contentsData.value.skilupId
      );
      // 引数のフェーズIDが設定されている場合は再設定
      if (phaseId != "") {
        contentsData.value.phaseId = phaseId;
      }

      // デバックログ
      console.log("Filtered Phases:", selectedSkilupPhaseList.value);
    };

    /** サムネイル画像クリア */
    const onThumbnailClear = () => {
      contentsData.value.thumbnailFile = "";
      contentsData.value.thumbnailFileList = [];
    };

    /**
     * スキルアップ名選択判定
     */
    const isSNonelectedSkilup = computed(() => {
      return contentsData.value.skilupId == "";
    });

    return {
      uploadProgress,
      errorMessage,
      isOpenKensakuTagModal,
      tags,
      kensakuTagModalodalTags,
      openKensakuTagModal,
      closeKensakuTagModal,
      updateKensakuTags,
      isInitError,
      contentsData,
      ContentRegConstants,
      contentsCaategoryName,
      isEditModeUpdate,
      isHyojiTaishoAll,
      isHyojiTaishoAgSegment,
      isHyojiTaishoAgCode,
      subCategoryList,
      agSegmentList,
      skilupList,
      onChangeHyojiTaisho,
      getValueKensakuTag,
      onPreview,
      onBack,
      onFixed,
      onDelete,
      hasContentsTempFile,
      hasContentsImgFile,
      hasContentsVideoFile,
      onRemoveContentsFile,
      getValueAgCodeUploadCnt,
      hyojiTaishoExtensions,
      tempFileExtensions,
      imgFileExtensions,
      videoFileExtensions,
      thumbnailFileExtensions,
      cmbSubCategory,
      agCodeFileInput,
      handleContentUpdate,
      isOpenPreviewModal,
      handlePreviewModalClosed,
      modalParamValueCategoryId,
      modalParamValueContentsId,
      isInitComplete,
      onAgCodeFileUpload,
      handleAgCodeFileUpload,
      tempFileInput,
      imgFileInput,
      videoFileInput,
      thumbnailFileInput,
      onContentsFileUpload,
      handleContentsFileSelected,
      AppConstants,
      onChangeSkilupList,
      selectedSkilupPhaseList,
      thumbNailList,
      isDataFetched,
      onThumbnailClear,
      isSNonelectedSkilup,
      isLoading,
    };
  },
});
</script>

<style scoped>
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 143px;
}
fieldset {
  border: 2px solid #ccc;
  padding: 10px;
  margin: 10px 0;
}
legend {
  font-weight: bold;
  padding: 0 10px;
  float: initial;
  width: initial;
  margin-bottom: initial;
  font-size: initial;
  line-height: initial;
}
.form-control-title {
  text-align: center;
  background-color: lightgrey;
  border-radius: 0.25rem;
}
.form-control {
  display: inline-block;
  vertical-align: middle;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
input[type="date"] {
  width: auto;
}
table {
  border-collapse: separate;
  width: 100%;
}
.form-check-input#chkJyuyo {
  margin: -0.2rem 0.2rem 0rem 0rem;
  vertical-align: inherit;
}
.form-check-input[name="hyojiTaisho"] {
  margin: 0rem 0.2rem 0rem 0rem;
  vertical-align: inherit;
}
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
td .btn-sm {
  width: 25px;
}
.file-upload {
  display: inline-block;
}
.vertical-align-top {
  vertical-align: top;
}
</style>

<style>
.ql-editor .color-ql-0_0_0 {
  color: rgb(0, 0, 0);
}

.ql-editor .color-ql-255_0_0 {
  color: rgb(255, 0, 0);
}

.ql-editor .color-ql-0_0_255 {
  color: rgb(0, 0, 255);
}

.ql-editor .color-ql-255_255_0 {
  color: rgb(255, 255, 0);
}

.ql-editor .color-ql-0_128_0 {
  color: rgb(0, 128, 0);
}

.ql-editor .color-ql-128_0_128 {
  color: rgb(128, 0, 128);
}
</style>
